

let _socket = null;

export const init = (socket) => {
    _socket = socket;
};

export const emitCommand = (payload) => {
    if (_socket) _socket.emit('command', payload);
    else console.warn('emitCommand: socket not connected');
};

export const onFeedback = (code, callback) => {
    if (!_socket) return () => {};

    const handler = (packet) => {
        if (packet.code === code) {
            _socket.off('feedback', handler);
            callback(packet);
        }
    };

    _socket.on('feedback', handler);
    return () => _socket.off('feedback', handler);
};

// Like onFeedback, but stays subscribed: multi-device commands send several
// packets per code ('partial' progress, then a final one). The caller must
// invoke the returned cleanup when it's done.
export const onFeedbackStream = (code, callback) => {
    if (!_socket) return () => {};
    const socket = _socket;
    const handler = (packet) => { if (packet.code === code) callback(packet); };
    socket.on('feedback', handler);
    return () => socket.off('feedback', handler);
};